import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tray title component.
 *
 * Tray titles are for rendering a title inside of the open tray menu.
 *
 * TrayTitle
 * @param {React.ComponentProps} props component props
 * @param {React.ReactChild} props.children rendered children
 * @returns {React.ReactElement} react element
 * @api public
 */
function TrayTitle(props) {
  return (
    <div className='row'>
      <div className='col-sm-12'>
        <div role='heading' aria-level='2' className='font-primary-bold h3'>{props.children}</div>
      </div>
    </div>
  );
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
TrayTitle.propTypes = {
  children: PropTypes.node
};

export default TrayTitle;
